import React, { useEffect } from 'react';

import {
    TooltipStateful as OrbTooltipStateful,
    TooltipStatefulProps as OrbTooltipStatefulProps,
} from '@yandex-360/orb-components/dist/components/Tooltip';

type TooltipContentWrapProps = Pick<OrbTooltipStatefulProps, 'content'> & {
    onShow?: () => void;
};
const TooltipContentWrap: React.FC<TooltipContentWrapProps> = ({ content, onShow }) => {
    useEffect(() => {
        onShow?.();
    }, [onShow]);

    return <>{content}</>;
};

type TooltipStatefulProps = OrbTooltipStatefulProps & TooltipContentWrapProps;
export const TooltipStateful: React.FC<TooltipStatefulProps> = ({ content, onShow, children, ...props }) => {
    return (
        <OrbTooltipStateful content={<TooltipContentWrap content={content} onShow={onShow} />} {...props}>
            {children}
        </OrbTooltipStateful>
    );
};
